import { LoanPageType, LoanType } from '../LoanConstants';

export const getLoanTypeForPageType = (pageType: LoanPageType) => {
    switch (pageType) {
        case LoanPageType.Construction:
            return LoanType.Construction;
        case LoanPageType.Rental:
            return LoanType.Rental;
        case LoanPageType.BuildRent:
            return LoanType.BuildRent;
        case LoanPageType.Model:
            return LoanType.Model;
        case LoanPageType.Land:
            return LoanType.Land;
        case LoanPageType.FixFlip:
            return LoanType.FixFlip;
        case LoanPageType.Bridge:
            return LoanType.Bridge;
        default:
            return null;
    }
};
